"use client";
import { NodeType, parse } from "node-html-parser";
import { Container } from "components/layout/Container";
import { ArticleNavigation } from "components/shared/ArticleNavigation";
import { CTABlock } from "components/shared/CTABlock";
import s from "./SampleArticle.module.scss";
import { PropsWithChildren, useEffect, useRef } from "react";
import { adjustArticleContent } from "utils/helpers";
import { Link } from "components/shared/Link";
import JsxParser from "react-jsx-parser";
import { CTACard } from "@/components/shared/CTACard";
import HTMLElement from "node-html-parser/dist/nodes/html";

type SampleArticleProps = PropsWithChildren<{
  article: string;
  prevArticle?: {
    heading: string;
    href: string;
  } | null;
  nextArticle?: {
    heading: string;
    href: string;
  } | null;
}>;

export const SampleArticle = ({ article, prevArticle, nextArticle, children }: SampleArticleProps) => {
  const articleDom = parse(article);

  const container = useRef<HTMLDivElement>(null);

  const body = articleDom.getElementsByTagName("body")[0] || articleDom;

  if (body) {
    body.querySelectorAll("*").forEach((element) => {
      element.removeAttribute("color");
      element.removeAttribute("face");
      element.removeAttribute("size");
    });

    // disable links after "References block";
    const targetIndex = body.childNodes.findIndex(
      (node) => node.textContent.trim().toLowerCase() === "references"
    );

    if (targetIndex > -1) {
      body.childNodes.slice(targetIndex).forEach((element) => {
        if (element.nodeType !== NodeType.ELEMENT_NODE) return;
        const anchors = (element as HTMLElement).querySelectorAll("a");

        anchors.forEach((anchor) => {
          const content = anchor.textContent;
          anchor.insertAdjacentHTML("afterend", content);
          anchor.remove();
        });
      });
    }
  }

  const beforeBanner = [];

  const afterBanner = [];

  let counter = 0;

  for (let i = 0; i < body.childNodes.length; i++) {
    if (counter >= 2) {
      afterBanner.push(body.childNodes[i].toString());
    } else {
      if (body.childNodes[i].nodeType === 1 && body.childNodes[i]) {
        if (body.childNodes[i].textContent.length > 100) {
          counter += 1;
        }
      }
      beforeBanner.push(body.childNodes[i].toString());
    }
  }

  // adjust content
  useEffect(() => {
    if (!container.current) return;

    adjustArticleContent(container.current);
  }, [container]);

  return (
    <section className={s.sectionArticle}>
      <Container className={s.inner}>
        {/*@ts-ignore*/}
        <main className={s.main}>
          <article ref={container} className={s.article}>
            {/*@ts-ignore*/}
            <JsxParser
              components={{
                // @ts-ignore
                a: Link as React.ComponentType,
              }}
              autoCloseVoidElements
              jsx={beforeBanner.reduce((prev, cure) => prev + cure, "")}
              className={s.article}
            />
            <CTABlock
              heading={
                <>
                  It’s time <span>to jumpstart</span> your paper!{" "}
                </>
              }
              subheading="Delegate your assignment to our experts and they will do the rest."
              btnLink="/order"
              btnText="Get custom essay"
              className={s.cta}
              key="cta"
            />
            {/*@ts-ignore*/}
            <JsxParser
              components={{
                // @ts-ignore
                a: Link as React.ComponentType,
              }}
              autoCloseVoidElements
              jsx={afterBanner.reduce((prev, cure) => prev + cure, "")}
              className={s.article}
            />
          </article>

          <ArticleNavigation entity="essay" prevLink={prevArticle} nextLink={nextArticle} />
          {children}
        </main>
        <div className={s.aside}>
          <CTACard
            heading={
              <>
                <span>Free yourself up</span> from research <br />
                and writing!
              </>
            }
            subheading="Hire an expert to write you a 100% unique paper aligned to your needs."
            btnText="Contact a pro"
            className={s.card}
          />
        </div>
      </Container>
    </section>
  );
};
